import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UntilDestroy } from '@ngneat/until-destroy';
import { environment } from '@environments/environment';
import { User, PL_API_CONFIG, PlAPIConfig } from 'pl-core-services';

@UntilDestroy()
@Component({
  selector: 'pl-provider-baa-signature',
  templateUrl: './provider-baa-signature.component.html',
  styleUrls: ['./provider-baa-signature.component.scss'],
})
export class ProviderBaaSignatureComponent {
  user: User = {
    username: '',
    first_name: '',
  };

  logoutHref: string;

  isPaid = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(PL_API_CONFIG) config: PlAPIConfig,
    private domSanitizer: DomSanitizer
  ) {
    this.logoutHref = `${config.login_url}/logout/`;
  }

  get baaSignUrl(): SafeUrl {
    const baaSignUrl =
      localStorage.getItem('BAA_SIGN_URL') || environment.baa_sign_url;
    return this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${baaSignUrl}&hosted=false#user_uuid=${this.data.userUuid}&account_uuid=${this.data.accountUuid}`
    );
  }
}
